/* eslint-disable no-unused-vars */
import React, { useEffect, useState} from 'react'
import axios from 'axios';
import Swal from "sweetalert2";
import { FaEdit, FaTimes } from "react-icons/fa";
import './kardex_borrado_style.css'
import { AiOutlineInfoCircle } from 'react-icons/ai';

function KardexBorrado() {
  const [users, setUsers] = useState([])
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [loading, setLoading] = useState(true)
  const [searchValue, setSearchValue] = useState("");
  
  const getUsers = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/kardex_borrado`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
        },
      });
      if (res.data.code === 1){
        setUsers(res.data.users)
        setLoading(false)
      }
      
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
      setLoading(true)
    }
  };
  
  const deleteUser = async ( email ) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if (result.isConfirmed) {
        await axios.delete(
          `${process.env.REACT_APP_URL_BACKEND}/kardex_borrado/${email}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
            },
          }
        );

        Swal.fire("¡Eliminado!", "El usuario ha sido eliminado.", "success");
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          "Cancelado",
          "Tu usuario está a salvo :)",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  }
  
  const updateUser = async (email) => {
    var id = email;
    try {
      // Obtener los datos del usuario a editar del servidor
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/kardex_borrado/${email}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
          },
        }
      );
      const userData = response.data.user;

      const result = await Swal.fire({
        title: "Editar Usuario",
        html:
          '<div class="form-grid">' +
          `<input type="text" id="first-name" class="swal2-input" placeholder="Nombre" value="${userData[0].first_name}">`+
          `<input type="text" id="last-name" class="swal2-input" placeholder="Apellido" value="${userData[0].last_name}">`+
          `<input type="email" id="email" class="swal2-input" placeholder="correo" value="${userData[0].email}">`+
          `<label class="mt-3 text-start">`+
          `Permiso back-office<input type="checkbox" id="admin_permission" class="" ${userData[0].admin_permission == 1 ? "checked" : ""}>`+
          `</label>`+
          `<input type="password" id="password" class="swal2-input" placeholder="Contraseña">`+
          `<br><font size="2">Dejar vacio si no desea cambiar contraseña</font><br>`+
          '<input type="password" id="password-confirm" class="swal2-input" placeholder="Confirme Contraseña">'+
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Actualizar",
        cancelButtonText: "Cancelar",
        preConfirm: function () {
          return new Promise(function (resolve) {
            resolve({
              first_name: document.getElementById('first-name').value,
              last_name: document.getElementById('last-name').value,
              email: document.getElementById('email').value.replace(/\s/g, ''),
              password: document.getElementById('password').value,
              password_confirm: document.getElementById('password-confirm').value,
              id: email,
              admin_permission: document.getElementById('admin_permission').checked,
            });
          });
        },
      });

      if (result.isConfirmed) {
        const updatedUserData = result.value;
        // Realizar la solicitud PUT al servidor para actualizar el usuario
        const updateResponse = await axios.put(
          `${process.env.REACT_APP_URL_BACKEND}/kardex_borrado/update`,
          updatedUserData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
            },
          }
        );
        Swal.fire(
          "¡Actualizado!",
          "El usuario ha sido actualizado exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          "Cancelado",
          "No se ha realizado ninguna actualización.",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };
  
  const createUser = async () => {
    try {
      const result = await Swal.fire({
        title: "Crear Usuario",
        html:
          '<div class="form-grid">' +
            '<input type="text" id="first-name" class="swal2-input" placeholder="Nombre(s)">' +
            '<input type="text" id="last-name" class="swal2-input" placeholder="Apellido(s)">' +
            '<input type="email" id="email" class="swal2-input" placeholder="Ejemplo@email.com">' +
            '<label class="mt-3 text-start">Permiso back-office <input type="checkbox" id="admin_permission" class=""></label>' +
            '<input type="password" id="password" class="swal2-input" placeholder="Contraseña">' +
            '<input type="password" id="password-confirm" class="swal2-input" placeholder="Confirme Contraseña">' +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Crear",
        cancelButtonText: "Cancelar",
        preConfirm: function () {
          return new Promise(function (resolve) {
            resolve({
              first_name: document.getElementById('first-name').value,
              last_name: document.getElementById('last-name').value,
              email: document.getElementById('email').value.replace(/\s/g, ''),
              password: document.getElementById('password').value,
              password_confirm: document.getElementById('password-confirm').value,
              admin_permission: document.getElementById('admin_permission').checked,
            });
          });
        },
      });
  
      if (result.isConfirmed) {
        const userData = result.value;
  
        const response = await axios.post(
          `${process.env.REACT_APP_URL_BACKEND}/kardex_borrado/create`,
          userData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        Swal.fire(
          "¡Creado!",
          "El usuario ha sido creado exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Accion cancelada.", "error");
      }
    } catch (error) {
      if (error.response.data.message === "El usuario ya existe") {
        Swal.fire("Error al crear el usuario", "El usuario ya existe.", "error");
      } else if (error.response.data.message === "El usuario fue eliminado anteriormente") {
        Swal.fire("Error al crear el usuario", "El usuario fue eliminado anteriormente", "error");
      } else if (error.response.data.error[0] === "La contraseña debe ser mayor a 6 caracteres") {
        Swal.fire("Error al crear el usuario", "La contraseña debe ser mayor a 6 caracteres", "error");
      } else if (error.response.data.error[0] === "El formato del correo no es valido") {
        Swal.fire("Error al crear el usuario", "El formato del correo no es valido", "error");
      } else {
        Swal.fire(
          "Error al crear el usuario",
          "No se ha creado ningún usuario."
        );
      }
    }
  };
  
  const handleSearch = () => {
    const input = document.getElementById("searchInput");
    setSearchValue(input.value.trim());
  };
  
  const filteredUsers = searchValue
  ? users.filter(
      (user) =>
        user.name
          .toUpperCase()
          .includes(searchValue.toUpperCase()) ||
        user.email.toUpperCase().includes(searchValue.toUpperCase())
    )
  : users

  useEffect(() => {
    getUsers();
  }, [updateTrigger]);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);

    // Obtener los componentes de la fecha
    const day = date.getDate();
    const month = date.getMonth() + 1; // getMonth() es base 0
    const year = date.getFullYear();

    // Obtener los componentes de la hora
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // Formatear los componentes del tiempo con ceros iniciales si son de un solo dígito
    const formattedHours = hours < 10 ? '0' + hours : hours;
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

    // Devolver la fecha y el tiempo en el formato deseado
    return `${day}/${month}/${year} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  };

  const getStatusClass = (status) => {
      if (status == 1) {
          return 'ready';
      } else if (status == 0) {
          return 'pending';
      } else if (status == 2) {
          return 'error';
      }
      return 'Nullo'; // Retorna una cadena vacía si el estado no coincide
  };

  const handleShowErrorSwal = (user) => {
      Swal.fire({
        title: `Error en la subida de: ${user.name}`,
        icon: 'error',
        width: '80%',
        html: `
          <h4>Información detallada del error:</h4>
          <p>${user.status_info}</p>
        `,
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#dc3545'
      });
    };

  return (
    <>
    <div className="panel-table">
    <div className='colum-left'>
      <input type="text" className='searchInput' id="searchInput" placeholder="Buscar..." />
      <button className='btnn' onClick={handleSearch}>Buscar</button>
    </div>
    </div>
    <div className='table-responsive'>
      <table className='table table-preve' id='tableToSearch'>
        <thead>
          <tr>
            <th>Fecha Inicio</th>
            <th>Fecha Fin</th>
            <th>Usuario</th>
            <th>Módulo</th>
            <th>Fecha Borrado</th>
            <th>Estatus</th>
            <th>Mensaje Estatus</th>
          </tr>
        </thead>
        
        <tbody>
        {loading ? (
          <tr><td>Cargando...</td></tr>
        ) : (
          [...filteredUsers].reverse().map((user) => (
          <tr key={user.id} data-master-id={user.id}>
            <td>{user.start_date}</td>
            <td>{user.end_date}</td>
            <td>{user.id_user}</td>
            <td>{user.place}</td>
            <td>{formatDate(user.created_at)}</td>
            <td className="">
              <span className={`dot ${getStatusClass(user.status)}`}></span>
              {user.status == 2 && (
                "Error"
              )}
              {user.status == 1 && (
                "Completo"
              )}
              {user.status == 0 && (
                "Procesando"
              )}
            </td>
            <td className="text-center">
                {user.status == 2 && (
                  <button 
                    className="info-button"
                    onClick={() => handleShowErrorSwal(user)}
                  >
                     <AiOutlineInfoCircle />
                  </button>
                )}
              </td>
          </tr>
        )))}
        </tbody>
      </table>
    </div>
    </>
  )
}

export default KardexBorrado